var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "progressBarForSignUp", class: { isPc: !_vm.isSp } },
    [
      _c(
        "ul",
        { staticClass: "progressBarForSignUpList" },
        _vm._l(_vm.processList, function (item, index) {
          return _c(
            "li",
            {
              key: item,
              staticClass: "progressBarForSignUpNumberWrapper",
              class: { disable: _vm.currentPhase < index + 1 },
            },
            [
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.currentPhase <= index + 1 && _vm.currentPhase !== 4,
                      expression:
                        "currentPhase <= index + 1 && currentPhase !== 4",
                    },
                  ],
                  staticClass: "progressBarForSignUpNumber",
                },
                [_vm._v("\n        " + _vm._s(index + 1) + "\n      ")]
              ),
              _vm._v(" "),
              _c("p", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.currentPhase > index + 1 || _vm.currentPhase === 4,
                    expression:
                      "currentPhase > index + 1 || currentPhase === 4",
                  },
                ],
                staticClass: "progressBarForSignUpNumber done",
              }),
              _vm._v(" "),
              _c("p", { staticClass: "progressBarForSignUpText" }, [
                _vm._v("\n        " + _vm._s(item) + "\n      "),
              ]),
            ]
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }